﻿import sidebarsContainerModule from '../Areas/Mobile/scripts/_common/sidebarsContainer/sidebarsContainer.module.js';

export default sidebarsContainerModule;
